import { POST } from "../../index";

export const selectMaintainProject = (param) => POST("/v1/maintainProject/selectMaintainProject", param);
export const insertMaintainProject = (param) => POST("/v1/maintainProject/insertMaintainProject", param);
export const updateMaintainProject = (param) => POST("/v1/maintainProject/updateMaintainProject", param);
export const deleteMaintainProject = (param) => POST("/v1/maintainProject/deleteMaintainProject", param);
export const selectProject = (param) => POST("/v1/maintainProject/selectProject", param);
export const selectTreeFormProject = (param) => POST("/v1/maintainProject/selectTreeFormProject", param);
